import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '../Session';
import { UserType } from '../api';
import BasicLayout from '../layouts/BasicLayout';
import Approvals from '../pages/Approvals';

const ApprovalsRoute = () => {
    const currentUser = useCurrentUser();

    if (![UserType.Admin, UserType.Root, UserType.SalesManager].includes(currentUser.type)) {
        return <Redirect to="/403" />;
    }

    return (
        <BasicLayout>
            <Approvals />
        </BasicLayout>
    );
};

export default ApprovalsRoute;
